import { styled } from "@mui/material";
import { editorToolbarName } from "../classes.js";
const Overflow = styled("div", {
  name: editorToolbarName,
  slot: "Overflow",
  overridesResolver: (_props, styles) => [styles.overflow],
  shouldForwardProp: (prop) => !["toolbarWidth", "sx", "ownerState"].includes(prop.toString())
})(({ toolbarWidth }) => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  flexDirection: "row",
  ...toolbarWidth > 0 && {
    maxWidth: toolbarWidth
  }
}));
export {
  Overflow
};
//# sourceMappingURL=Overflow.js.map
